import React from 'react'
import PaymentForm from './Forms/Payment/PaymentForm'
import CustomizeForm from './Forms/Customize/CustomizeForm'
import PaymentDetails from './PaymentDetails/PaymentDetails'
import CustomizeDetails from './CustomizeDetails/CustomizeDetails'

import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import './PaymentBody.scss'

const stripePromise = loadStripe(
  'pk_live_4Zc9xS8JHoATN5VkoJe4242w',
)

const PaymentBody = ({ pageType, state }) => {
  return (
    <div className="PaymentPage">
      <div className="PaymentPage__Wrapper">
        <div className="PaymentPage__Wrapper__Form">
          <div className="Pp__Form__Wrapper">
            {pageType === 'customize' ? (
              <CustomizeForm />
            ) : (
              <Elements stripe={stripePromise}>
                {' '}
                <PaymentForm state={state} />{' '}
              </Elements>
            )}
          </div>
          <div className="rightSide">
            {pageType === 'customize' ? <CustomizeDetails /> : <PaymentDetails state={state} />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentBody
